import React, { useEffect, useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as Sentry from '@sentry/react';

const FIELD_MAP = [
    { label: 'CO2 Saved', key: 'CO2' },
    { label: 'Trees grown to maturity', key: 'TreesGrown' },
    { label: 'kWh saved', key: 'KWHSaved' },
    { label: 'Homes powered', key: 'HomesPowered' },
    { label: 'Liters of water saved', key: 'LitersSaved' },
    { label: 'Average households annual water', key: 'HomesWater' },
    { label: 'Trees saved', key: 'TreesSaved' },
    { label: 'Acres of Tropical Forest saved', key: 'TropicalForest' },
    { label: 'SMART electricity', key: 'SMARTELEC' },
    { label: 'SMART bulk connections', key: 'SMARTBULK' },
    { label: 'SMART water', key: 'SMARTWATER' }
];

const SustainabilityPortfolioStats = () => {
    const { apiFetch } = useAuth();
    const [fields, setFields] = useState(
        FIELD_MAP.reduce((acc, { key }) => ({ ...acc, [key]: '' }), {})
    );
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const fetchStats = async () => {
            setLoading(true);
            try {
                const response = await apiFetch('/api/Ops/sustainability-stats');
                const data = await response.json();
                if (data) {
                    setFields(
                        FIELD_MAP.reduce((acc, { key }) => ({
                            ...acc,
                            [key]: typeof data[key] === 'number' ? data[key] : ''
                        }), {})
                    );
                }
            } catch (catchError) {
                Sentry.captureException(catchError);
                toast.error('Failed to load sustainability stats');
            } finally {
                setLoading(false);
            }
        };
        fetchStats();
    }, [apiFetch]);

    const handleChange = (key, value) => {
        if (value === '' || (/^\d*\.?\d*$/.test(value))) {
            setFields(prev => ({ ...prev, [key]: value }));
        }
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            const payload = FIELD_MAP.reduce((acc, { key }) => ({
                ...acc,
                [key]: Number(fields[key]) || 0
            }), {});
            const response = await apiFetch('/api/Ops/sustainability-stats', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                toast.success('Sustainability stats saved!');
            } else {
                toast.error('Save failed');
            }
        } catch (catchError) {
            Sentry.captureException(catchError);
            toast.error('Save failed');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div style={{ maxWidth: 500, margin: '0 auto', padding: 24 }}>
            <h2>Sustainability Portfolio Stats</h2>
            {loading ? (
                <div>Loading...</div>
            ) : (
                <form
                    onSubmit={e => {
                        e.preventDefault();
                        handleSave();
                    }}
                >
                    {FIELD_MAP.map(({ label, key }) => (
                        <div key={key} style={{ marginBottom: 16 }}>
                            <label htmlFor={key}>{label}</label>
                            <input
                                id={key}
                                type="number"
                                min="0"
                                step="any"
                                value={fields[key]}
                                onChange={e => handleChange(key, e.target.value)}
                                style={{ width: '100%', padding: 8, marginTop: 4 }}
                                required
                            />
                        </div>
                    ))}
                    <button type="submit" disabled={saving}>
                        {saving ? 'Saving...' : 'Save'}
                    </button>
                </form>
            )}
</div>
    );
};

export default SustainabilityPortfolioStats;